import { filterOutContainerMcBimSpaces, isPointInPolygon } from "../DesignTab/containerSpaceFilter";

type ItemPosition = {
  centerPoint?: number[] | null;
  buildingStory?: { name?: string | null } | null;
};
type RoomPolygon = {
  name?: string | null;
  polygon?: number[][] | null;
  buildingStory?: { name?: string | null } | null;
};

export function hasObjectRoomPosition(item: ItemPosition | null | undefined): boolean {
  return !!item?.buildingStory?.name && !!item.centerPoint
    && Number.isFinite(item.centerPoint[0]) && Number.isFinite(item.centerPoint[1]);
}

/** Use the same floor + center-point convention as the items-in-space API. */
export function findSelectedObjectRoom(item: ItemPosition | null | undefined, spaces: RoomPolygon[]): string | undefined {
  const point = item?.centerPoint;
  const floor = item?.buildingStory?.name;
  if (!floor || !point || !Number.isFinite(point[0]) || !Number.isFinite(point[1])) return undefined;
  const rooms = filterOutContainerMcBimSpaces(spaces.filter(space => space.buildingStory?.name === floor));
  const names = new Set(rooms.filter(space => space.name && isPointInPolygon([point[0], point[1]], space.polygon)).map(space => space.name!));
  // Duplicate representations of one room are fine; overlapping different rooms are ambiguous.
  return names.size === 1 ? [...names][0] : undefined;
}
